<template>
  <v-dialog v-model="itemDetalhesModal" scrollable persistent full-width max-width='933'>
    <v-card>
      <v-card-title>
        <v-flex>
          <span class="titulo-detalhes pl-4  mt-2 mb-2 headline">{{item.id === '' ? 'Novo item' : item.name }}</span>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-btn icon @click.native="itemDetalhesModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-title>
        <v-card-text class="pa-0">
          <v-form name="form-cadastro" ref="itemForm">
            <v-layout row wrap class="pl-5 pr-5" style="background-color:#f5f5f5" v-show="true">              
              <v-flex xs12 sm12 md2 class="titulo-detalhes-categoria">
                Categorias
              </v-flex>
              <v-flex xs12 sm12 md4>
                <v-select
                  v-bind:items="categories"
                  :rules="rules.categories"
                  :value="item.categories"      
                  v-model="setLocale"                          
                  @input="updateCategories"
                  item-text="name"
                  item-value="id"     
                  label=""        
                  single-line
                  bottom
                  required>
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12 pb-5 class="titulo-detalhes">
                Detalhes
              </v-flex>
              <v-flex xs12 md12 pb-3 class="logo">
                <p>Imagem do Item</p>
                <div v-if="isImg" class="item-image-box">
                  <img :src="item.images[0]" alt="">
                  <div class="photo-actions">
                    <div class="alter">
                      <v-icon>insert_photo</v-icon> Alterar
                      <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                    </div>
                    <div class="remove" @click="removeImage">
                      <v-icon>close</v-icon> Remover
                    </div>
                  </div>
                </div>
                <template v-else>
                  <v-layout row wrap v-if="shelfedImage !== ''">
                    <v-flex xs6 md3 mr-3 v-if="cropperOn">
                      <div>
                        <img :src="shelfedImage"  alt="" id="imgToCrop" >
                      </div>
                      <div class="crop-action" @click="crop">
                        <v-icon>done</v-icon> Recortar
                      </div>
                    </v-flex>
                    <v-flex xs6 md3>
                      <div class="cropped-box">
                        <div class="crop-preview">
                          <img :src="shelfedImage" :style="cropPreviewStyle" alt="" >
                        </div>
                        <div class="photo-actions" v-if="!cropperOn">
                          <div class="alter">
                            <v-icon>insert_photo</v-icon> Alterar
                            <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                          </div>
                          <div class="remove" @click="unshelfImage" >
                            <v-icon>close</v-icon> Remover
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                  <template v-else>
                    <input class="invisible-all" type="file" name="" value="" v-on:change="shelfImage">
                    <div class="item-image-box">
                      <div class="pa-2 noselect foto">
                        <v-icon>insert_photo</v-icon>
                        imagem do item
                      </div>
                    </div>
                  </template>
                </template>
              </v-flex>
              <v-flex xs11 sm11 md11>
                <v-text-field
                name="nome"
                label="Nome do item"
                :rules="rules.name"
                :value="typeof item.name !== 'undefined' ? item.name : ''"
                @input="updateName"
                required
                >
                </v-text-field>                
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Insira o nome do item.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 sm11 md5>
                <v-text-field
                  name="descricao"
                  label="Descrição"
                  :rules="rules.description"
                  :value="typeof item.description !== 'undefined' ? item.description : ''"
                  @keypress.enter.prevent
                  @input="updateDescription"
                  multi-line>
                </v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Descreva detalhadamente o item e suas características.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 sm11 md5>
                <v-text-field
                  label="Palavra Chave"
                  @keyup.enter="addTag"
                  :append-icon="dataTags !== '' ? 'send' : ''"
                  :append-icon-cb="addTag"
                  v-model="dataTags">
                </v-text-field>
                <v-chip v-for="(tag, index) in item.tags" :key="index"
                  close
                  @input="removeTag(tag)">
                  {{ tag }}
                </v-chip>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Informe palavras que descrevam o item.</span>
                </v-tooltip>
              </v-flex>                                       
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs11 sm5 md3>
                <v-text-field
                  label="Seu Código"
                  @input="updateCode"
                  :value="item.code">
                </v-text-field>
              </v-flex>
              <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Caso seu item possua um código de controle interno, informe aqui.</span>
                </v-tooltip>
              </v-flex>
              <v-flex xs11 sm11 md3>
                <v-text-field
                  label="Familia"
                  @input="updateFamily"
                  :value="item.family"
                  >
                </v-text-field>                
              </v-flex>
               <v-flex xs1 sm1 md1 pt-4 pl-3>
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Ex.: limpeza, pet, alimentação, etc.</span>
                </v-tooltip>
              </v-flex>
            </v-layout>           
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs8 sm8 md6>
                <v-layout row wrap>
                  <v-flex sm12 md12 class="titulo-detalhes">
                    Ativo
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <p>Escolha 'SIM', caso queira que este item apareça no catálogo de produtos/serviços.</p>
                    <SelectionBtn :value="item.active" @input="toggleActive"/>
                  </v-flex>
                </v-layout>
              </v-flex>      

              <v-flex xs4 sm4 md6>
                <v-layout row wrap>
                  <v-flex sm4 md4 class="">
                        <v-text-field
                        label="Sequencia"
                        @input="updateSeq"
                        :value="item.seq">
                        </v-text-field>
                  </v-flex>  
                  <v-flex xs1 sm1 md1 pt-4 pl-3>
                  <v-tooltip right>
                    <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                    <span>Campo sequencia - ordenar os itens por prioridades de visualização, ou seja, os itens que devem ser visualizados primeiro..</span>
                  </v-tooltip>
              </v-flex>                
                </v-layout>
              </v-flex>   
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md6>
                <v-layout row wrap>
                  <v-flex sm12 md12 class="titulo-detalhes">
                    Vigência
                    <v-tooltip right>
                      <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                      <span>Determina quando começa e quando termina a exibição do item.</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex xs12 sm6 md6 pr-2>
                    <v-menu
                      lazy
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      full-width
                      :nudge-right="40"
                      max-width="290px"
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        label="Início"
                        v-model="validityStartLabel"
                        prepend-icon="event"
                        readonly
                        >
                      </v-text-field>
                      <v-date-picker
                        :value="validityStartPicker"
                        @input="updateValidityStart"
                        :first-day-of-week="1"
                        locale="pt-br"
                        no-title
                        scrollable
                        actions
                        >                     
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6 pl-2>
                    <v-menu
                    lazy
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    max-width="290px"
                    min-width="290px"
                    >
                    <v-text-field
                      slot="activator"
                      label="Fim"
                      v-model="validityEndLabel"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker
                      :value="validityEndPicker"
                      @input="updateValidityEnd"
                      :first-day-of-week="1"
                      locale="pt-br"
                      no-title
                      scrollable
                      actions
                      >                  
                    </v-date-picker>
                  </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12 class="titulo-detalhes">
                Variações
              </v-flex>
              <v-flex xs12 sm12 md12>
                <p>Escolha 'SIM', caso este produto/serviço tenha variações no preço.
                  <v-tooltip right>
                    <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                    <span>Ex: Pequeno, Médio, Grande...</span>
                  </v-tooltip>
                </p>
                <SelectionBtn :value="variacao" @input="togglePriceVariations"/>
              </v-flex>              
            </v-layout>

            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12 class="titulo-detalhes">
                Preço
              </v-flex>
              <v-flex md12 mb-3>
                <template v-if="item.priceVariations">
                  <v-flex md12 class="box-variacao mt-2" ref="pricetableList">
                    <template v-for="(variation, index) of item.priceTable">
                      <v-layout row wrap :key="index">
                        <v-flex xs12 sm1 md1 variation-img-box>
                          <img :src="variation.image" alt="" class="variation-img" />
                          <div class="box-change-img">
                            <button type="button" @click="uploadImage(index, variation.image)">alterar</button>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm3 md3 pr-2>
                          <div class="price-box">
                            <v-text-field
                              :value="variation.description"                        
                              label="Descricão"
                              required
                              :rules="rules.multiDescription"
                              @input="updatePriceText($event, index)">
                          </v-text-field>
                        </div>
                      </v-flex>
                      <v-flex xs4 sm3 md3>
                        <div class="price-box">                          
                          <money
                            :label="'Valor Referência'"                        
                            v-model="variation.priceRef"
                            >
                          </money>                          
                        </div>                      
                      </v-flex>
                      <v-flex xs1 sm1 md1 pt-2>
                        <v-tooltip right>
                          <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                          <span>Valor original sem desconto.</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs4 sm3 md3>
                        <div class="price-box">                                                  
                          <money                
                            v-model="variation.price"
                            :validation="true"
                            >
                          </money>
                        </div>                      
                      </v-flex>
                      <v-flex xs1 sm1 md1 pt-2>
                        <v-tooltip right>
                          <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                          <span>Valor com desconto.</span>
                        </v-tooltip>
                        <v-icon @click.stop="deleteMultiPrice(index)">delete</v-icon>
                      </v-flex>
                    </v-layout>
                  </template>   
                  <br/>               
                  <div class="">
                    <v-icon @click.stop="addMultiPrice">add</v-icon>
                  </div>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 sm3 md3 mt-3>
                    <div class="price-box">                      
                      <money                                              
                        v-model="item.price"                        
                        :validation="true"
                        >
                      </money>
                    </div>
                  </v-flex>
                </template>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12 class="titulo-detalhes">
                Formas de pagamento
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-select
                v-bind:items="payments"
                :value="item.payments"
                multiple              
                @input="updatePayments"
                item-text="description"
                item-value="id"
                label=""
                single-line
                bottom
                required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 sm12 md12 class="titulo-detalhes">
                O tipo de serviço que sua empresa presta requer definição de horários?
                <v-tooltip right>
                  <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                  <span>Coloque sim, caso o tipo de serviço prestado pela sua empresa tenha horários de atendimentos diferenciados durante a semana.</span>
                </v-tooltip>   
              </v-flex>
              <v-flex xs12 sm12 md12>
                <SelectionBtn class="font-14" :value="needSchedule" @input="toggleNeedSchedule"/> 
              </v-flex>
            </v-layout>

            <div row class="pl-5 pr-5 mt-3">
              <v-layout  row wrap v-if="needSchedule">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Sábado</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.saturdayStart"
                    @change="updateSaturdayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.saturdayEnd"
                    @change="updateSaturdayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.saturdayInterval"
                    @change="updateSaturdayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.saturdayCapacity"
                    @change="updateSaturdayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>  
              <v-layout  row wrap v-if="needSchedule">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Domingo</p>
                </v-flex>
                <v-flex xs4 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.sundayStart"
                    @change="updateSundayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.sundayEnd"
                    @change="updateSundayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.sundayInterval"
                    @change="updateSundayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.sundayCapacity"
                    @change="updateSundayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout  row wrap v-if="needSchedule">
                <template v-if="!customTime">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Segunda a Sexta</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.weekDayStart"
                    @change="updateWeekdayStart"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.weekDayEnd"
                    @change="updateWeekdayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.weekDayInterval"
                    @change="updateWeekdayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.weekDayCapacity"
                    @change="updateWeekdayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
                </template>
                <template v-else>
                  <v-flex xs12 sm3 md2>
                    <p class="mt-4 mb-0">Segunda</p>
                  </v-flex>
                  <v-flex xs6 sm3 md2 class="pr-3">
                    <v-text-field
                      label="Início"
                      :value="item.mondayStart"
                      @change="updateMondayStart"
                      mask="##:##"
                      >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3 md2 class="pr-3">
                    <v-text-field
                      label="Fim"
                      :value="item.mondayEnd"
                      @change="updateMondayEnd"
                      mask="##:##"
                      >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.mondayInterval"
                    @change="updateMondayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.mondayCapacity"
                    @change="updateMondayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
                </template>
              </v-layout>
              <v-layout  row wrap v-if="needSchedule && customTime">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Terça</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.tuesdayStart"
                    @change="updateTuesdayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.tuesdayEnd"
                    @change="updateTuesdayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.tuesdayInterval"
                    @change="updateTuesdayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.tuesdayCapacity"
                    @change="updateTuesdayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout  row wrap v-if="needSchedule && customTime">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Quarta</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.wednesdayStart"
                    @change="updateWednesdayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.wednesdayEnd"
                    @change="updateWednesdayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.wednesdayInterval"
                    @change="updateWednesdayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.wednesdayCapacity"
                    @change="updateWednesdayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout  row wrap v-if="needSchedule && customTime">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Quinta</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.thursdayStart"
                    @change="updateThursdayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.thursdayEnd"
                    @change="updateThursdayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.thursdayInterval"
                    @change="updateThursdayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.thursdayCapacity"
                    @change="updateThursdayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout  row wrap v-if="needSchedule && customTime">
                <v-flex xs4 sm3 md2>
                  <p class="mt-4 mb-0">Sexta</p>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Início"
                    :value="item.fridayStart"
                    @change="updateFridayStart"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs6 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Fim"
                    :value="item.fridayEnd"
                    @change="updateFridayEnd"
                    mask="##:##"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Tempo de atendimento"
                    :value="item.fridayInterval"
                    @change="updateFridayInterval"
                    mask="##:##"
                    masked="true"
                    >
                  </v-text-field>
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                    <span>Qual é o tempo médio de realização dos serviços.</span>
                  </v-tooltip> 
                </v-flex>
                <v-flex xs5 sm3 md2 class="pr-3">
                  <v-text-field
                    label="Atendimentos simultâneos"
                    :value="item.fridayCapacity"
                    @change="updateFridayCapacity"
                    >
                  </v-text-field>  
                </v-flex>
                <v-flex xs1 sm1 md1 class="pr-3">
                  <v-tooltip right>
                    <v-icon class="link mt-3" slot="activator" color="blue">help_outline</v-icon>
                      <span>Quantos atendimentos simultâneos você poderá realizar nesse período.</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="needSchedule">
                <v-flex xs12 sm3 md6>
                  <p class="">Horários distintos durante a semana</p>
                  <SelectionBtn :value="customTime" @input="toggleCustomTime"/>
                  <v-tooltip right>
                    <v-icon class="ml-2 link" slot="activator" color="blue">help_outline</v-icon>
                    <span>Se o tipo de serviço prestado pela sua empresa tem horários de atendimentos diferenciados durante a semana, preencha a próxima tela.</span>
                  </v-tooltip>    
                </v-flex>
              </v-layout>
            </div>

            <v-layout row wrap class="pl-5 pr-5 mt-3">
              <v-flex xs12 mt-3 class="text-xs-center">
                <v-spacer></v-spacer>
                <v-btn flat outline round color="green" class="mb-4" :disabled="loadingItemAction" @click.native="updateItem()"><v-icon left>done_all</v-icon>Gravar</v-btn>              
              </v-flex>
            </v-layout>
          <v-progress-linear class="loading-modal" v-if="loadingItemAction" color="error" v-bind:indeterminate="true"></v-progress-linear>
        </v-form>
      </v-card-text>
      <v-flex>      
      <ImageUpload />
    </v-flex>
    </v-card>
  </v-dialog>
  
</template>

<script>
import SelectionBtn from '@/components/SelectionBtn'
import Galeria from './Galeria'
import moment from 'moment'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { setTimeout } from 'timers'
import ImageUpload from './imageUpload'

export default {
  name: 'item-detalhes',
  components: {
    SelectionBtn,
    Galeria,
    Cropper,
    ImageUpload
  },
  data () {
    return {
      dataTags: '',
      setLocale: '',
      ativo: false,
      cropper: false,
      cropperOn: false,
      cropPreviewStyle: {
        width: '0',
        height: '0',
        transform: ''
      },
      termsOfUseDialog: false,
      rules: {
        categories: [
          (v) => !!v > 0 || 'Selecione uma categoria'
          // (v) => this.categories.filter(elem => elem === v).length === 1 || 'Categoria inválida'
        ],
        name: [
          (v) => v.length > 0 || 'Insira um nome para o item'
        ],
        description: [
          (v) => v.length > 0 || 'Insira uma descrição',
          (v) => v.length < 251 || 'Descrição muito longa'
        ],
        tags: [
          (v) => v.length > 100 || 'Máximo de 100 caracteres por tag'
        ],
        singlePrice: [
          (v) => v.length > 0 || 'Insira um valor'
        ],
        multiPrice: [
          (v) => !!v > 0 || 'Insira um valor'
        ],
        multiDescription: [
          (v) => v.length > 0 || 'Insira uma descrição'
        ]
      }
    }
  },
  created () {
    setTimeout(() => {
      this.setLocale = this.item.categories
    }, 1500)
  },
  methods: {
    priceValidation () {
      let validation = true
      if (this.$store.getters.selectedItemPriceVariations) {
        if (this.$refs.pricetableList.classList.contains('price-table-error')) {
          this.$refs.pricetableList.classList.remove('price-table-error')
        }
        const priceTable = this.$store.getters.selectedItemPriceTable
        priceTable.forEach(element => {
          if (element.priceRef !== '' && element.priceRef !== null) {
            if (element.priceRef <= element.price) {
              validation = false
              this.$refs.pricetableList.classList.add('price-table-error')
            }
          }
        })
        if (!validation) {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'Valor referência tem de ser maior que valor cadastrado'
          })
        }
      }
      return validation
    },
    updateItem () {
      if (this.priceValidation()) {
        if (this.validityStartPicker === null && this.validityEndPicker === null) {
          if (this.$refs.itemForm.validate()) {
            this.$store.dispatch('updateItem')
          } else {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'Verifique os campos em vermelho'
            })
          }
        } else {
          if (moment(this.item.validityStart).diff(moment(this.item.validityEnd)) <= 0) {
            if (this.$refs.itemForm.validate()) {
              this.$store.dispatch('updateItem')
            } else {
              this.$store.commit('toastr', {
                color: 'info',
                texto: 'Verifique os campos em vermelho'
              })
            }
          } else {
            this.$store.commit('toastr', {
              color: 'info',
              texto: 'O campo vigência final não pode ser menor que a inicial'
            })
            return
          }
        }
      }
    },
    saveTermsOfUse () {
      this.$store.commit('updateTermsOfUseContent', this.editorContent)
      this.termsOfUseDialog = false
    },
    cancelTermsOfUse () {
      this.editorContent = ''
    },
    toggleActive () {
      this.$store.commit('toggleActive')
    },
    updateName (value) {
      this.$store.commit('updateName', value)
    },
    updateDescription (value) {
      this.$store.commit('updateDescription', value)
    },
    updateCode (value) {
      this.$store.commit('updateCode', value)
    },
    updateRealizationTime (value) {
      this.$store.commit('updateRealizationTime', value)
    },
    addTag () {
      if (this.dataTags.length > 100) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Máximo de 100 caracteres por tag'
        })
        return
      }
      this.$store.commit('addTag', this.dataTags)
      this.dataTags = ''
    },
    removeTag (tag) {
      this.$store.commit('removeTag', tag)
    },
    updateValidityStart (value) {
      if (moment(value).diff(moment(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de inicio não pode estar no passado'
        })
        return
      }
      if (this.validityEndPicker !== null) {
        if (moment(value).diff(moment(this.item.validityEnd)) <= 0) {
          this.$store.commit('updateValidityStart', value)
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data de inicio não pode ser maior que a final'
          })
        }
      } else {
        this.$store.commit('updateValidityStart', value)
      }
    },
    updateValidityEnd (value) {
      if (moment(value).diff(moment(), 'days') < 0) {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'A data de fim não pode estar no passado'
        })
        return
      }
      if (this.validityStartPicker !== null) {
        if (moment(value).diff(moment(this.item.validityStart)) >= 0) {
          this.$store.commit('updateValidityEnd', value)
        } else {
          this.$store.commit('toastr', {
            color: 'info',
            texto: 'A data final não pode ser menor que o inicio'
          })
        }
      } else {
        this.$store.commit('updateValidityEnd', value)
      }
    },
    updateFamily (value) {
      this.$store.commit('updateFamily', value)
    },
    updateSeq (value) {
      this.$store.commit('updateSeq', value)
    },
    updateCategories (value) {
      this.$store.commit('updateCategories', value)
    },
    updatePayments (value) {
      this.$store.commit('updatePayments', value)
    },
    togglePriceVariations (value) {
      this.$store.commit('togglePriceVariations')
    },
    formatPrice (value) {
      value = parseFloat(String(value).replace(',', '.'))
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    updateSinglePrice (elem) {
      this.$store.commit('updateSinglePrice', elem)
    },
    updateMultiPrice (elem, index) {
      if (elem !== '') {
        this.$store.commit('updateMultiPrice', {
          index: index,
          value: elem
        })
      }
    },
    updatePriceText (elem, index) {
      if (elem !== '') {
        this.$store.commit('updatePriceText', {
          index: index,
          value: elem
        })
      }
    },
    updateMultiPriceRef (elem, index) {
      if (elem !== '') {
        this.$store.commit('updateMultiPriceRef', {
          index: index,
          value: elem
        })
      }
    },
    deleteMultiPrice (index) {
      this.$store.commit('deleteMultiPrice', index)
    },
    addMultiPrice () {
      this.$store.commit('addMultiPrice')
    },
    close () {
      this.$store.commit('unshelfImage')
      this.$store.commit('closeItem')
    },
    removeImage () {
      this.$store.commit('updateImage', '')
    },
    updateImage (value) {
      this.$store.commit('updateImage', value)
    },
    shelfImage (elem) {
      let image = {
        elem: elem.target.files[0],
        size: elem.target.files[0].size,
        extension: elem.target.value.substring(elem.target.value.lastIndexOf('.') + 1).toLowerCase()
      }
      if (image.size > 3000000) {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma image de até 3mb'
        })
        return
      }
      if (image.extension === 'gif' || image.extension === 'png' || image.extension === 'bmp' ||
      image.extension === 'jpeg' || image.extension === 'jpg') {
        this.$store.dispatch('shelfImage', image.elem)
      } else {
        this.$store.commit('toastr', {
          color: 'error',
          texto: 'Insira uma imagem com a extensão .png'
        })
      }
    },
    unshelfImage () {
      this.$store.commit('unshelfImage')
    },
    toggleNeedSchedule () {
      this.$store.commit('toggleNeedSchedule')
    },
    toggleCustomTime () {
      this.$store.commit('toggleCustomTime')
    },
    updateWeekdayStart (value) {
      this.$store.commit('updateWeekdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayEnd (value) {
      this.$store.commit('updateWeekdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayInterval (value) {
      this.$store.commit('updateWeekdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWeekdayCapacity (value) {
      this.$store.commit('updateWeekdayCapacity', value)
    },
    updateSundayStart (value) {
      this.$store.commit('updateSundayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayEnd (value) {
      this.$store.commit('updateSundayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayInterval (value) {
      this.$store.commit('updateSundayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSundayCapacity (value) {
      this.$store.commit('updateSundayCapacity', value)
    },
    updateMondayStart (value) {
      this.$store.commit('updateMondayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayEnd (value) {
      this.$store.commit('updateMondayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayInterval (value) {
      this.$store.commit('updateMondayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateMondayCapacity (value) {
      this.$store.commit('updateMondayCapacity', value)
    },
    updateTuesdayStart (value) {
      this.$store.commit('updateTuesdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayEnd (value) {
      this.$store.commit('updateTuesdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayInterval (value) {
      this.$store.commit('updateTuesdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateTuesdayCapacity (value) {
      this.$store.commit('updateTuesdayCapacity', value)
    },
    updateWednesdayStart (value) {
      this.$store.commit('updateWednesdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayEnd (value) {
      this.$store.commit('updateWednesdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayInterval (value) {
      this.$store.commit('updateWednesdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateWednesdayCapacity (value) {
      this.$store.commit('updateWednesdayCapacity', value)
    },
    updateThursdayStart (value) {
      this.$store.commit('updateThursdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayEnd (value) {
      this.$store.commit('updateThursdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayInterval (value) {
      this.$store.commit('updateThursdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateThursdayCapacity (value) {
      this.$store.commit('updateThursdayCapacity', value)
    },
    updateFridayStart (value) {
      this.$store.commit('updateFridayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayEnd (value) {
      this.$store.commit('updateFridayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayInterval (value) {
      this.$store.commit('updateFridayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateFridayCapacity (value) {
      this.$store.commit('updateFridayCapacity', value)
    },
    updateSaturdayStart (value) {
      this.$store.commit('updateSaturdayStart', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayEnd (value) {
      this.$store.commit('updateSaturdayEnd', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayInterval (value) {
      this.$store.commit('updateSaturdayInterval', value.length === 4 ? (value.substring(0, 2) + ':' + value.substring(2)) : '')
    },
    updateSaturdayCapacity (value) {
      this.$store.commit('updateSaturdayCapacity', value)
    },
    crop () {
      this.$store.commit('updateImageCrop', this.cropper.getData())
      this.cropper.destroy()
      this.cropper = false
      this.cropperOn = false
    },
    uploadImage (index, img) {
      this.$store.commit('updateImgUploadIndex', index)
      this.$store.commit('updateImgUploadImage', img)
      this.$store.commit('toggleImgUploadModal', true)
    }
  },
  computed: {
    termoDeUso: {
      get () {
        return '<p>troioioioi</p>'
      },
      set (value) {
        // console.log('valor mudado', value)
      }
    },
    loadingItemAction () {
      return this.$store.getters.loadingItemAction
    },
    termsOfUseContent () {

    },
    validityEndPicker () {
      return this.item.validityEnd === null ? null : moment(this.item.validityEnd).format('YYYY-MM-DD')
    },
    validityStartPicker () {
      return this.item.validityStart === null ? null : moment(this.item.validityStart).format('YYYY-MM-DD') || null
    },
    validityEndLabel () {
      return this.item.validityEnd === null ? null : moment(this.item.validityEnd).format('DD-MM-YYYY')
    },
    validityStartLabel () {
      return this.item.validityStart === null ? null : moment(this.item.validityStart).format('DD-MM-YYYY') || null
    },
    item () {
      return this.$store.getters.selectedItem
    },
    categories: {
      get () {
        this.setLocale = this.item.categories
        return this.$store.getters.categories
      },
      set () {
        this.$store.commit('updateCategories', this.item.categories)
      }
    },
    payments () {
      return this.$store.getters.payments
    },
    families () {
      return this.$store.getters.families
    },
    dataInicio () {
      return this.formatar(this.item.validityStart)
    },
    dataFim () {
      return this.formatar(this.item.validityEnd)
    },
    variacao () {
      return this.item.priceVariations
    },
    itemDetalhesModal: {
      get () {
        return this.$store.getters.itemVisible
      },
      set () {
        this.dataTags = ''
        this.$store.commit('toggleItemModal', false)
      }
    },
    isImg () {
      return this.$store.getters.isImg
    },
    shelfedImage () {
      return this.$store.getters.shelfedImage
    },
    needSchedule () {
      return this.$store.getters.selectedItem.needSchedule
    },
    customTime () {
      return this.$store.getters.selectedItem.customTime
    }
  },
  watch: {
    shelfedImage () {
      if (this.shelfedImage) {
        this.cropperOn = true
        let vueObj = this
        this.$nextTick(() => {
          let cropper = new Cropper(document.getElementById('imgToCrop'), {
            viewMode: 3,
            aspectRatio: 1,
            movable: false,
            zoomable: false,
            handleWidth: 16,
            handleOffset: -10,
            crop (event) {
              let scale = 200 / event.detail.width
              vueObj.cropPreviewStyle.width = event.target.width * scale + 'px'
              vueObj.cropPreviewStyle.height = event.target.height * scale + 'px'
              vueObj.cropPreviewStyle.transform = 'translateX(-' + (event.detail.x * scale) + 'px) translateY(-' + (event.detail.y * scale) + 'px)'
            }
          })
          this.cropper = cropper
        })
      } else {
        if (this.cropper) {
          this.cropper.destroy()
          this.cropper = false
        }
      }
    }
  }
}
</script>
<style>
.prefix.input-group--prefix:not(.input-group--focused):not(.input-group--dirty) label{
  left: 23px!important;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.item-imagem{
  width: 60px;
  float: left;
}
.item-detalhes{
  float: left;
  width: calc(100% - 60px);
  width: -moz-calc(100% - 60px);
}
.item-imagem img{
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 10px;
}
.item-detalhes .item-titulo{
  font-size: 20px;
  margin-bottom: 0px;
}

.item-preco, .item-rodape, .item-cabecalho{
  float: left;
  width: 100%;
}
.price-value-align-right {
  text-align: right!important;
}
.price-table-error {
  border: 1.5px solid red;
}
.logo{
  position: relative;
}
.invisible-all{
  z-index: 1;
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  width: 100%;
}
.outerDiv{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

}
input[type=file]::-webkit-file-upload-button {
  display: none;
}
.photo-actions > div > i{
  color:#fff!important
}
.photo-actions > div{
  float: left;
  width: 50%;
  position: absolute;
  text-align: center;
  bottom: 0;
  cursor: pointer;
  height:30px;
}
.photo-actions .remove{
  right: 0;
}
.photo-actions{
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  color:#fff!important;
  background-size: cover;
  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');
}
/* ajustes */
.titulo-detalhes{
    color: #e62039;
    font-size: 21px;
}
.titulo-detalhes .headline{
  font-size: 25px;
}
.titulo-detalhes-categoria{
  font-size: 21px;
  padding-top: 17px;
  color: #707983
}
p{
  color: #838789
}
.crop-preview{
  width: 200px;
  height: 200px;
  overflow: hidden;
  text-align: center;
}
.crop-preview img{
  max-width: none;
  max-height: none;
  min-width: 0;
  min-height: 0;
  display: block;
}
#imgToCrop{
  max-width: 200px;
  max-height: 200px;
}
.item-image-box img{
  width: 200px;
  height: 200px;
}
.crop-action{
  cursor: pointer;
  width: 200px;
  text-align: center;
}
.cropped-box, .item-image-box{
  width: 200px;
  height: 200px;
  position: relative;
}
.variation-img-box{
  position:relative;
}
.variation-img-box .box-change-img{
  display:none;
  position: absolute;
  top:0;
  left: 0;
  height:80%;
  width: 80%;
  background-size: cover;
  background-image: url('https://www.ettravel.com/wp-content/uploads/2016/06/GRADIENT-OVERLAY.png');
}
.variation-img-box .box-change-img button{
  position:absolute;
  bottom:4px;
  left:0;
  width: 100%;
  color:#fff;
  outline: none;
}
.variation-img-box:hover .box-change-img{display: block;}
.variation-img{
  max-width: 80%;
}

</style>



// WEBPACK FOOTER //
// itemDetalhes.vue?22dae0ac